import React, { useState } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Collapse, Nav } from "react-bootstrap";
import { NavLink, useLocation } from "react-router-dom";
import NavbarVerticalMenuItem from "./NavbarVerticalMenuItem";
import { useAppContext } from "providers/AppProvider";
import { useSelector } from "react-redux"; // Added for Redux access

const CollapseItems = ({ route }) => {
  const { pathname } = useLocation();

  const openCollapse = (childrens) => {
    const checkLink = (children) => {
      if (children.to === pathname) {
        return true;
      }
      return (
        Object.prototype.hasOwnProperty.call(children, "children") &&
        children.children.some(checkLink)
      );
    };
    return childrens.some(checkLink);
  };

  const [open, setOpen] = useState(openCollapse(route.children));

  return (
    <Nav.Item as="li">
      <Nav.Link
        onClick={() => {
          setOpen(!open);
        }}
        className={classNames("dropdown-indicator cursor-pointer", {
          "text-500": !route.active,
        })}
        aria-expanded={open}
        // {...route}
      >
        <NavbarVerticalMenuItem route={route} />
      </Nav.Link>
      <Collapse in={open}>
        <Nav className="flex-column nav" as="ul">
          <NavbarVerticalMenu routes={route.children} />
        </Nav>
      </Collapse>
    </Nav.Item>
  );
};

CollapseItems.propTypes = {
  route: PropTypes.shape({
    name: PropTypes.string.isRequired,
    icon: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    children: PropTypes.array.isRequired,
    active: PropTypes.bool,
  }).isRequired,
};

const NavbarVerticalMenu = ({ routes }) => {
  const {
    config: { showBurgerMenu },
    setConfig,
  } = useAppContext();

  const { userData } = useSelector((state) => state.auth);

  // const hasSystemPrivilege = useSelector(
  //   (state) => state.auth.user.hasSystemPrivilege || false
  // ); // Assuming Redux state has auth.user.hasSystemPrivilege; adjust path as per your Redux store
  const hasSystemPrivilege = userData?.employee?.user_id == 1;
  const handleNavItemClick = () => {
    if (showBurgerMenu) {
      setConfig("showBurgerMenu", !showBurgerMenu);
    }
  };

  return routes.map((route) => {
    // Check if route requires privilege and disable if not granted
    const isDisabled = route.requiresPrivilege && !hasSystemPrivilege;

    // Hide "System Privillage" if !hasSystemPrivilege
    if (route.name === "Roles" && !hasSystemPrivilege) {
      return null; // Do not render the route
    }

    if (!route.children) {
      return (
        <Nav.Item as="li" key={route.name} onClick={handleNavItemClick}>
          <NavLink
            end={route.exact}
            to={route.to}
            target={route?.newtab && "_blank"}
            onClick={(e) => {
              if (isDisabled || route.soon) {
                e.preventDefault(); // Prevent navigation if disabled or soon
              }
              if (route.name === "Modal") {
                setConfig("openAuthModal", true);
              }
            }}
            className={({ isActive }) =>
              isActive && route.to !== "#!"
                ? "active nav-link"
                : `nav-link ${isDisabled || route.soon ? "disabled" : ""}`
            }
          >
            <NavbarVerticalMenuItem route={route} />
          </NavLink>
        </Nav.Item>
      );
    }
    return <CollapseItems route={route} key={route.name} />;
  });
};

NavbarVerticalMenu.propTypes = {
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      to: PropTypes.string,
      exact: PropTypes.bool,
      icon: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
      children: PropTypes.array,
      active: PropTypes.bool,
      newtab: PropTypes.bool,
      badge: PropTypes.shape({
        type: PropTypes.string,
        text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }),
      soon: PropTypes.bool,
      requiresPrivilege: PropTypes.bool,
    })
  ).isRequired,
};

export default NavbarVerticalMenu;
